// @flow
import type { Node } from "react"

export type Notice = null | {|
  id: string,
  type: "info" | "success" | "warning" | "critical",
  icon: boolean | React$Element<*>,
  closable: boolean,
  onClose: ?() => void,
  title: React$Element<React$ComponentType<any>> | string,
  content: Node,
  ttl: ?number,
|}

type NoticeSetAction = {
  type: "notice/SET",
  notice: Notice,
}

type NoticeClearAction = {
  type: "notice/CLEAR",
  id: ?string,
}

type NoticeAction = NoticeSetAction | NoticeClearAction

const NOTICE_SET = "notice/SET"
const NOTICE_CLEAR = "notice/CLEAR"

export default function NoticeReducer(state: Notice, action: NoticeAction) {
  switch (action.type) {
    case NOTICE_SET:
      return action.notice
    case NOTICE_CLEAR:
      return !action.id || (state && action.id === state.id) ? null : state
    default:
      return state || null
  }
}

type NoticeOptions = {|
  id: string,
  type?: "info" | "success" | "warning" | "critical",
  icon?: boolean,
  closable?: boolean,
  onClose?: () => void,
  title?: React$Element<React$ComponentType<any>> | string,
  content?: Node,
  ttl?: number,
|}

const defaultNoticeOptions = {
  type: "info",
  icon: true,
  closable: false,
  onClose: null,
  title: undefined,
  content: null,
  ttl: null,
}

export const setNotice = (options: NoticeOptions): NoticeAction => ({
  type: NOTICE_SET,
  notice: {
    ...defaultNoticeOptions,
    ...options,
  },
})

export const clearNotice = (id?: string): NoticeAction => ({
  type: NOTICE_CLEAR,
  id,
})
